require('./friend.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/hdcp/hdcp-module')
require('../components/error-handler/error-handler-module')
require('../components/animate/animate-module')

# Load Css
require('../../../sass/web/html/_friend.scss')

FriendCtrl =    require('./friend-controller')
FriendService = require('./friend-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-form'
  'gnp-hdcp'
  'gnp-animate'
  'gnp-error-handler'
]
angular.module 'gnp-app-friend', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/friend',
      templateUrl: 'web/friend/friend.jade'
      controller: 'FriendCtrl'
      title: '_FRIEND.TITLE'
      permission:
        signInRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'FriendCtrl', FriendCtrl
  .factory 'FriendService', FriendService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/friend/friend-module.coffee